import { render, staticRenderFns } from "./EventHighlightsFeaturedImage.vue?vue&type=template&id=093b3823&scoped=true"
import script from "./EventHighlightsFeaturedImage.vue?vue&type=script&lang=ts"
export * from "./EventHighlightsFeaturedImage.vue?vue&type=script&lang=ts"
import style0 from "./EventHighlightsFeaturedImage.vue?vue&type=style&index=0&id=093b3823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b3823",
  null
  
)

export default component.exports